/**
 * API base URL — resolved at build time via Vite env variables.
 *
 * In development: empty string (Vite proxy forwards /auth and /api to localhost:8787)
 * In production:  full Workers URL (e.g. https://heart-of-science-api-production.zbyszek-34e.workers.dev)
 */
export const API_BASE = import.meta.env.VITE_API_URL ?? ''
